module.exports = __webpack_public_path__ + "static/media/PB_G_14.ab372479.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_14.png
// module id = 227
// module chunks = 0